<mps-loader></mps-loader>
<div class="skiplinks">
  <nav role="navigation" aria-label="Accès rapide" attr.aria-label="{{ 'skiplinks.quick_access' | translate }}">
    <ul class="skiplinks__list">
      <li>
        <a id="skiplink__content" href="home#content" class="link">
          {{ 'skiplinks.content' | translate }}
        </a>
      </li>
      <li>
        <a id="skiplink__menu" href="home#main-nav" class="link">
          {{ 'skiplinks.menu' | translate }}
        </a>
      </li>
      <li>
        <a id="skiplink__pied-de-page" href="home#footer" class="link">
          {{ 'skiplinks.footer' | translate }}
        </a>
      </li>
    </ul>
  </nav>
</div>
<mat-sidenav-container class="h-100">
  <mat-sidenav id="main-nav" #snav position="end" mode="over" role="navigation">
    <mps-app-navigation></mps-app-navigation>
  </mat-sidenav>
  <mat-sidenav-content class="app-sidenav-content" role="main">
    <mps-app-header [nav]="snav"></mps-app-header>
    <main id="content">
      <router-outlet></router-outlet>
    </main>
    <mps-app-footer id="footer"></mps-app-footer>
  </mat-sidenav-content>
</mat-sidenav-container>
